var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-xl-8 mx-auto"},[_c('div',[_vm._m(0),_c('br'),_c('b-table',{staticClass:"table-light",attrs:{"striped":"","items":_vm.questionsAndAnswers,"fields":_vm.fields}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h3',[_c('b',{staticClass:"text-lg-center"},[_vm._v("Frequently Asked Questions")])])
}]

export { render, staticRenderFns }